import { ICustomComponent } from '../models/module-layout.model';
import { moduleLayout } from '../redux/reducers';
import { map, distinctUntilChanged } from 'rxjs/operators';
import { filter } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { Store, select } from '@ngrx/store';
import { Injectable } from '@angular/core';
import { TModuleLayout } from '../models/module-layout.model';
import { joinCapitalCase } from '@uxdf/direct-shared-lib';

@Injectable({ providedIn: 'root' })
export class LayoutConfigService {
  constructor(private readonly store: Store<any>) {}

  getModuleLayout(name: string): Observable<TModuleLayout> {
    return this.store.pipe(
      select(moduleLayout({ name })),
      filter(layoutState => !layoutState.isLoading && layoutState.layout && layoutState.layout.length > 0),
      distinctUntilChanged(),
      map(layoutState => this.withFullIds(name, layoutState.layout))
    );
  }

  /**
   * Non-lazy modules should display components if their ids present in id list
   * (to avoid listing all their components as entryComponents)
   * Ids are generated in camel case according to the format:
   * <module><rootComponent.template_code>...<parent.template_code><this.template_code>
   */
  getModuleEnabledComponents(name: string): Observable<{ [id: string]: boolean }> {
    return this.getModuleLayout(name).pipe(map(this.collectLayoutIds.bind(this)));
  }

  private withFullIds(prefix: string, layout: TModuleLayout): TModuleLayout {
    const result = [];
    for (const component of layout) {
      const id = prefix + joinCapitalCase((component as ICustomComponent).template_code || component.type);
      const children = component.layout ? [...this.withFullIds(id, component.layout)] : [];
      result.push({ ...component, id, layout: children });
    }
    return result;
  }

  private collectLayoutIds(layout: TModuleLayout): { [id: string]: boolean } {
    const ids = {};
    for (const component of layout) {
      ids[component.id] = true;
      if (component.layout) {
        Object.assign(ids, this.collectLayoutIds(component.layout));
      }
    }
    return ids;
  }
}
